/**
 * Thin API client for LIVE Poll-block voting (Bucket-D Wave-D2).
 *
 * Wraps the ALREADY-LIVE backend routes under `/wheel/forms/poll/` (see
 * yuga_wheel/api/v1/form_blocks_views.py — Wave-5 Lane-N BLOCK-FORMS). Uses the
 * shared axios instance (services/request.js) so Token auth + interceptors apply
 * (voting is AllowAny, but a logged-in voter is de-duplicated by user server-side).
 *
 * `blockId` is the poll block's craft.js node id within the wheel; `wheelId` is
 * the wheel being viewed. The duplicate-vote policy is enforced SERVER-side per
 * the block's own `allowMultiple` setting: single-choice REPLACES a voter's prior
 * vote, multi-choice keeps one row per distinct option. The endpoints are
 * Premium-gated on the wheel OWNER's tier server-side and 403 (upgrade code) when
 * the owner is not Premium — callers handle that gracefully.
 *
 * The FE only calls these from the published view (craft Editor enabled === false)
 * and only when POLL_LIVE_VOTING_ENABLED is ON, so a half-flipped state is inert.
 */
import axios from "./request";

/**
 * Cast a poll vote.
 * @param {number|string} wheelId
 * @param {string} blockId - craft.js node id of the Poll block
 * @param {{ optionIds: string[], allowMultiple?: boolean }} payload
 * @returns axios promise -> { tallies: {optionId: count}, total, you_voted }
 */
export function castPollVote(wheelId, blockId, { optionIds, allowMultiple = false }) {
  return axios.post(`/wheel/forms/poll/${wheelId}/${blockId}/vote/`, {
    option_ids: optionIds,
    allow_multiple: allowMultiple,
  });
}

/**
 * Fetch current poll tallies.
 * @returns axios promise -> { tallies: {optionId: count}, total }
 */
export function getPollResults(wheelId, blockId) {
  return axios.get(`/wheel/forms/poll/${wheelId}/${blockId}/results/`);
}
